import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Sunrise, X } from "lucide-react";
import { api } from "@/lib/api";
import { LiveLinks } from "@/components/LiveUpdateCard";

// Collapsing remembers this digest only; each new morning's digest starts open.
const KEY = "middle_digest_collapsed";

const Issue = ({ i }) => (
  <div className="px-5 py-4" data-testid={`digest-issue-${i.live_id}`}>
    <div className="flex items-baseline justify-between gap-3">
      <p className="font-serif text-lg">{i.live_title}</p>
      <span className="shrink-0 text-xs text-slate-500">{i.count} new</span>
    </div>
    <ul className="mt-1.5 space-y-1">{i.headlines.map((h) => (
      <li key={h.id}><Link to={`/facts/${h.id}`} className="text-sm text-slate-700 hover:text-slate-900 hover:underline" data-testid={`digest-headline-${h.id}`}>{h.headline}</Link> <span className="text-xs text-slate-400">· {h.source_name}</span></li>
    ))}</ul>
    <p className="mt-2 text-xs"><LiveLinks liveId={i.live_id} testid={`digest-${i.live_id}`} /></p>
  </div>
);

export const DigestCard = () => {
  const [d, setD] = useState(null);
  const [closed, setClosed] = useState(false);
  useEffect(() => { api.get("/feed/digest").then((r) => { setD(r.data); setClosed(!!r.data && localStorage.getItem(KEY) === r.data.id); }).catch(() => {}); }, []);
  if (!d) return null;
  const dismiss = () => { api.post(`/feed/digest/${d.id}/dismiss`).catch(() => {}); setD(null); };
  const toggle = () => { const c = !closed; setClosed(c); c ? localStorage.setItem(KEY, d.id) : localStorage.removeItem(KEY); };
  const total = d.issues.reduce((n, i) => n + i.count, 0);
  return (
    <section className="surface overflow-hidden fade-up" data-testid="digest-card">
      <div className="flex items-center gap-2 bg-[#13352C] px-5 py-3 text-white">
        <button onClick={toggle} aria-expanded={!closed} className="flex min-w-0 flex-1 items-center gap-2 text-left" data-testid="digest-toggle">
          <Sunrise size={16} className="shrink-0 text-amber-300" />
          <span className="whitespace-nowrap text-[11px] font-semibold uppercase tracking-[0.14em]"><span className="hidden sm:inline">Your morning Live digest</span><span className="sm:hidden">Morning digest</span></span>
          <span className={`whitespace-nowrap text-xs text-emerald-100/70 ${closed ? "" : "hidden sm:inline"}`} data-testid="digest-summary">· {closed ? `${d.issues.length} issue${d.issues.length === 1 ? "" : "s"}, ${total} new` : "overnight verified updates"}</span>
          <ChevronDown size={16} className={`ml-auto shrink-0 text-emerald-100/80 transition-transform duration-200 ${closed ? "" : "rotate-180"}`} aria-label={closed ? "Show digest" : "Collapse digest"} />
        </button>
        <button onClick={dismiss} className="rounded-full p-1 text-emerald-100/70 hover:bg-white/10 hover:text-white" aria-label="Dismiss digest" data-testid="digest-dismiss"><X size={15} /></button>
      </div>
      {!closed && <div className="divide-y divide-border" data-testid="digest-body">{d.issues.map((i) => <Issue key={i.live_id} i={i} />)}</div>}
    </section>
  );
};
